import { render, staticRenderFns } from "./oil-gun.vue?vue&type=template&id=4e864ce1&"
import script from "./oil-gun.vue?vue&type=script&lang=js&"
export * from "./oil-gun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports